import { ApolloClient } from "apollo-boost"
import { NextComponentType } from "next"
import React from "react"
import { ApolloConsumer } from "react-apollo"

interface Props {}

interface WrappedComponentProps {
    apolloClient: ApolloClient<any>
}

const withApolloClient = <P extends WrappedComponentProps>(WrappedComponent: NextComponentType<P>) => {
    class WithApolloClient extends React.Component<P & Props> {
        static getInitialProps

        render() {
            return (
                <ApolloConsumer>
                    {apolloClient => <WrappedComponent {...this.props} apolloClient={apolloClient} />}
                </ApolloConsumer>
            )
        }
    }

    if (WrappedComponent.getInitialProps) {
        WithApolloClient.getInitialProps = WrappedComponent.getInitialProps
    }

    return WithApolloClient
}

export default withApolloClient
